import React, { useState, useEffect } from "react";
import axios from "axios";
import logo from "../assets/images/logo_q88.png";
import ticket from "../assets/images/ticket.svg";
import "../assets/styles/style.css";
import homeIcon from "../assets/images/home.svg";
import arrow from "../assets/images/arrow-circle-right.png"
import form from "../assets/images/form.png";
import button_ktn from "../assets/images/button_ktn.png";
import {
  addPointClient,
  getCaptchaTokenClient,
  getCodeClient,
} from "../services/api.service";
import Swal from "sweetalert2";
import moment from "moment-timezone";

import { information } from "../const/info.const";
const PromoPage = () => {
  const [promoCode, setPromoCode] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [captchaBase64, setCaptchaBase64] = useState("");

  useEffect(() => {
    if (captchaBase64) {
      document.getElementById("captcha-image").src = captchaBase64;
    }
  }, [captchaBase64]);

  const handleCheckCode = async () => {
    if (!promoCode.trim()) {
      setWarningMessage("Mã Code không được bỏ trống");
      return;
    }
    let valueCode = promoCode.trim();
    Swal.fire({
      titleText: "Đang kiểm tra ...",
      color: "#ffffff",
      allowOutsideClick: false,
      background: `rgba(0, 103, 25, 1)`,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      let loadCaptcha = await getCaptchaTokenClient();
      setCaptchaBase64(loadCaptcha.captchaUrl);
      document.cookie = `token=${loadCaptcha.token}; max-age=180; path=/`;
      let tokenCaptcha = loadCaptcha.token;
      Swal.fire({
        title: "Mã Xác Thực",
        showConfirmButton: false,
        allowOutsideClick: false,
        html: `
        <div class="input-form-captcha-wrapper">
          <div class="thumb-captcha">
            <img id="captcha-image" class="image-captcha notranslate" src="" alt="Captcha Image">
          </div>
          <div class="input-form-captcha">
            <input class="notranslate" translate="no" type="text" placeholder="Nhập mã captcha" id="captcha-input">
            </input>
          </div>
        </div>
        <button id="verify-captcha" class="swal2-confirm swal2-styled">Xác Thực</button>
      `,
      });

      document.getElementById("captcha-image").src = loadCaptcha.captchaUrl;
      document
        .getElementById("captcha-image")
        .addEventListener("click", async () => {
          let newCaptcha = await getCaptchaTokenClient();
          setCaptchaBase64(newCaptcha.captchaUrl);
          tokenCaptcha = newCaptcha.token;
          document.cookie = `token=${newCaptcha.token}; max-age=180; path=/`;
          document.getElementById("captcha-image").src = newCaptcha.captchaUrl;
        });

      document
        .getElementById("verify-captcha")
        .addEventListener("click", async () => {
          const captchaInputValue =
            document.getElementById("captcha-input").value;
          console.log("clientTokenclientTokenclientToken", tokenCaptcha);
          Swal.fire({
            titleText: "Đang kiểm tra ...",
            color: "#ffffff",
            allowOutsideClick: false,
            background: `rgba(0, 103, 25, 1)`,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          let codeResult = await getCodeClient(
            valueCode,
            captchaInputValue,
            tokenCaptcha
          );
          Swal.close();
          if (codeResult.status_code === 403) {
            Swal.fire({
              icon: "error",
              allowOutsideClick: false,
              title: codeResult.title_mess,
              background: "none",
              html:
                "<div class='modal-text-wrapper'>" +
                "<div class='modal-text-cont'>" +
                "<p class='modal-text'>Mã Code: &nbsp;</p>" +
                "<p style='font-weight: 600'>" +
                codeResult.detail.promo_code +
                "</p>" +
                "</div>" +
                "<div class='modal-text-cont'>" +
                "<p class='modal-text'>Điểm thưởng: &nbsp;</p>" +
                "<p style='font-weight: bold; color:#ec164c'>" +
                codeResult.detail.point +
                "&nbsp; điểm</p>" +
                "</div>" +
                "</div>",
              footer:
                '<a class="cskh" href="' +
                information?.cskh_url +
                '" target="_blank">Chăm sóc khách hàng 24/7</a>',
            }).then(() => {
              window.location.reload();
            });
          } else if (codeResult.status_code === 400) {
            Swal.fire({
              icon: "error",
              title: "Lỗi xác thực",
              text: "Mã captcha không đúng. Vui lòng thao tác lại.",
            });
            return;
          } else {
            if (codeResult.valid === false) {
              Swal.fire({
                icon: "warning",
                title: codeResult.title_mess,
                text: codeResult.text_mess,
                footer:
                  '<a href="' +
                  information?.cskh_url +
                  '" target="_blank">Chăm sóc khách hàng 24/7.</a>',
              }).then(() => {
                window.location.reload();
              });
            } else if (codeResult.valid === true) {
              let time = moment(codeResult.detail.time)
                .tz("Asia/Ho_Chi_Minh")
                .format("DD/MM/YYYY, H:mm:ss");
              const { value: input_data } = await Swal.fire({
                allowOutsideClick: false,
                html: `
                <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 16px;">
                  <div class="outer-circle">
                    <div class="inner-circle">
                      <div class="checkmark"></div>
                    </div>
                  </div>
                </div>
                <h2>${codeResult.title_mess}</h2>
                <table style="width: 100%; margin-bottom: 16px; text-align: left;">
                  <tbody>
                    <tr>
                      <td>Mã Code:</td>
                      <td class="align-right"><strong>${codeResult?.detail?.promo_code}</strong></td>
                    </tr>
                    <tr>
                      <td>Điểm thưởng:</td>
                      <td class="pointbonus align-right"><strong>${codeResult?.detail?.point} điểm </strong></td>
                    </tr>
                    <tr>
                      <td>${codeResult?.detail?.mess}:</td>
                      <td class="align-right">${time}</td>
                    </tr>
                  </tbody>
                </table>
              `,
                footer:
                  '<a href="' +
                  information?.cskh_url +
                  '" target="_blank">Chăm sóc khách hàng 24/7</a>',
                input: "text",
                inputLabel: "Vui lòng nhập tên tài khoản để nhận thưởng",
                inputPlaceholder: "Tên tài khoản",
                showCancelButton: true,
                cancelButtonText: "Hủy",
                confirmButtonText: "Xác nhận",
                inputValidator: async (value) => {
                  if (!value) {
                    return "Vui lòng nhập tên tài khoản!";
                  }
                },
              });
              if (input_data) {
                Swal.fire({
                  text: "Đang cộng điểm ...",
                  allowOutsideClick: false,
                  width: 300,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                });
                let addPoint = await addPointClient(
                  input_data,
                  codeResult.detail.promo_code
                );
                if (addPoint.status_code === 502) {
                  Swal.fire({
                    icon: "warning",
                    title: addPoint.title_mess,
                    text: addPoint.text_mess,
                    footer:
                      '<a href="' +
                      information?.cskh_url +
                      '" target="_blank">Chăm sóc khách hàng 24/7.</a>',
                  }).then(() => {
                    window.location.reload();
                  });
                } else {
                  if (addPoint.valid === false) {
                    Swal.fire({
                      icon: "error",
                      title: addPoint.title_mess,
                      text: addPoint.text_mess,
                      footer:
                        '<a href="' +
                        information?.cskh_url +
                        '" target="_blank">Chăm sóc khách hàng 24/7.</a>',
                    }).then(() => {
                      window.location.reload();
                    });
                  } else if (addPoint.valid === true) {
                    await Swal.fire({
                      html: `
                      <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 16px;">
                        <div class="outer-circle">
                          <div class="inner-circle">
                            <div class="checkmark"></div>
                          </div>
                        </div>
                      </div>
                      <h2>Chúc mừng</h2>
                      <p>
                        Chúc mừng <strong class="pointbonus">${addPoint?.player_id}</strong> đã nhận thành công 
                        <span style="color: red; font-weight: bold;">${addPoint?.point} điểm</span>
                      </p>
                    `,
                      showCancelButton: false,
                      confirmButtonText: "TIẾP TỤC",
                      customClass: {
                        confirmButton: "popup-button confirm",
                      },
                      allowOutsideClick: false,
                    }).then(() => {
                      window.location.reload();
                    });
                  }
                }
              }
            }
          }
        });
    } catch (error) {
      console.error("Error fetching code:", error);
    }
    //  finally {
    //   Swal.close(); // Ensure Swal is closed after the operation
    // }
  };

  return (
    <div className="body">
      <div
        className="promo-page"
        style={{
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          display: "flex",
          width: "100%",
          height: "100%",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="thumb-logo">
          <img src={logo} alt="QQ88" className="promo-logo" />
          <div>
            <button className="btn btn-login">
              <a href="https://qq88.io/trangchu">Đăng Nhập</a>
            </button>
            <button className="btn btn-register">
              <a href="https://qq88.io/trangchu">Đăng Ký</a>
            </button>
          </div>
        </div>
        <div className="body-content">
          <div className="form-image">
            <img src={form} alt="Form" className="form-image" />

            <div className="promo-form">
              {/*<h1 className="promo-title">NHẬP CODE NHẬN THƯỞNG</h1>*/}
              <div className="input-container">
                <label className="promo-label" htmlFor="promo-code">
                  <img src={ticket} alt="Ticket Icon" className="coupon-icon" />
                  <span className="label-text">Mã khuyến mãi</span>
                </label>
                <input
                  id="promo-code"
                  type="text"
                  placeholder="Nhập mã CODE"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  className="promo-input"
                />

                {warningMessage && (
                  <p className="warning-message">{warningMessage}</p>
                )}
                <a className="promo-link-a" target="_blank" href="https://qq88.io/trangchu/khuyenmai" rel="noreferrer">
                  Thông tin trang code <span className="arrow"><img src={arrow} alt="arrow" /></span>
                </a>
              </div>
            </div>
            <button onClick={handleCheckCode} className="button ">
              <img src={button_ktn} alt="Kiểm tra" className="button-ktn" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoPage;
